
















import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

import DigitalCurrency12QrCodeScannerPresentation from './digital-currency-12-qr-code-scanner-presentation.vue'

import {
  GET_ACCOUNT_BY_QR_CODE_REQUEST
} from './service-for-helper-constants/helper-constants-3'

@Component({
  components: {
    DigitalCurrency12QrCodeScannerPresentation
  }
})
class DigitalCurrency11QrCodeScannerButton extends Vue {
  @Prop({ default: false }) isIconButton?: boolean
  @Prop({ default: false }) isDepressedButton?: boolean

  GET_ACCOUNT_BY_QR_CODE_REQUEST: string = GET_ACCOUNT_BY_QR_CODE_REQUEST

  isVisibleGetAccountByQrCodeScannerPresentationDialog: boolean = false

  toggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.isVisibleGetAccountByQrCodeScannerPresentationDialog = isVisible
  }
}

export default DigitalCurrency11QrCodeScannerButton

